/* eslint-disable react/require-default-props */
import { useAsyncEffect, useRenderFile } from '@/hooks';
import { downloadBlob, getFileExtensionFromFileName } from '@/lib/utils';
import React, { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import ModalBase from '../ModalBase';
import styles from './file-preview-modal.less';
import classNames from 'classnames';
interface FilePreviewModalProps {
  visible: boolean;
  fileName: string;
  azureBlobName: string;
  fetchUrl?: () => Promise<string | undefined>;
  fetchBlob?: () => Promise<Blob>;
  onClose: () => void;
}

export const FilePreviewModal = ({
  visible,
  onClose,
  fileName,
  azureBlobName,
  fetchBlob,
  fetchUrl,
}: FilePreviewModalProps) => {
  const [file, setFile] = useState<Blob>();
  const [url, setUrl] = useState<string>();
  const fileExtension = getFileExtensionFromFileName(fileName);
  const [isFetchingBlob, setIsFetchingBlob] = useState(false);

  const { renderedFile, isWord, isExcel } = useRenderFile({
    fileExtension,
    fileLocation: url,
    blob: file,
    fileName,
    azureBlobName,
  });

  useAsyncEffect(async () => {
    if (fetchBlob) {
      setIsFetchingBlob(true);

      const blob = await fetchBlob();

      setFile(blob);
      setIsFetchingBlob(false);
    }
  }, []);

  useAsyncEffect(async () => {
    if (fetchUrl) {
      const url = await fetchUrl();
      setUrl(url);
    }
  }, []);

  const getRenderedFile = () => {
    if (fetchBlob && isFetchingBlob) {
      return 'Loading file...';
    }

    if (renderedFile) {
      return (
        <div
          className={classNames(styles.file_preview_container, {
            [styles.document]: isWord || isExcel,
          })}
          // We just show a download link for word and excel files, so we don't need much space
          style={{ height: isWord || isExcel ? 150 : undefined }}
        >
          <div className={styles.download_text}>
            Click the download button below to download this file.
            <br />
            <br />
            {isWord &&
              'You will need a program that can open Microsoft Word documents in order to open this file.'}
            {isExcel &&
              'You will need a program that can open Microsoft Excel documents in order to open this file.'}
          </div>
          {isWord || isExcel ? null : renderedFile}
        </div>
      );
    }

    return 'No file selected...';
  };

  return (
    <Modal size="large" open={visible}>
      <ModalBase
        header={`${fileName} Preview`}
        onCancel={async () => onClose()}
        onAccept={async () => {
          if (file) {
            downloadBlob(file, fileName);
          }
        }}
        actionWord="Download"
        cancelWord="Close"
      >
        {getRenderedFile()}
      </ModalBase>
    </Modal>
  );
};
